import React from 'react';
import {
  TextField,
  Toggle,
  FlatButton,
  Card,
  CardHeader,
  CardActions,
  CardText,
} from 'material-ui';
import { grey400 } from 'material-ui/styles/colors';
import Trashcan from 'material-ui/svg-icons/action/delete';
import {
  required,
  translate as t,
} from 'admin-on-rest';
import QuestionListBuilder from './QuestionListBuilder';
import withConfirmDialog from './Hocs/withConfirmDialog';

const TRANSLATION_PREFIX = 'resources.quizes.fields.checkpoints';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes.checkpoints';
const STYLES = {
  block: {
    display: 'block',
  },
  toggleInput: {
    display: 'block',
    width: '256px',
    fontSize: '16px',
    marginTop: '24px',
  },
  basicLabelStyle: {
    color: grey400,
  },
  cardActions: {
    textAlign: 'right',
  },
};

const FlatButtonWithConfirm = withConfirmDialog(FlatButton);

class CheckpointForm extends React.Component {
  state = {
    title: {
      errorText: null,
      touched: false,
    },
    text: {
      errorText: null,
      touched: false,
    },
    buttonText: {
      errorText: null,
      touched: false,
    },
    video: {
      errorText: null,
      touched: false,
    },
    minCorrectAnswers: {
      errorText: null,
      touched: false,
    },
  }
  onRemove = () => {
    this.props.onRemove(this.props.id);
  }

  titleOnChange = (ev) => {
    this.change('title', ev.target.value);
    this.setState({
      title: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  textOnChange = (ev) => {
    this.change('text', ev.target.value);
    this.setState({
      text: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  buttonTextOnChange = (ev) => {
    this.change('buttonText', ev.target.value);
    this.setState({
      buttonText: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  videoOnChange = (ev) => {
    this.change('video', ev.target.value);
    this.setState({
      video: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  minCorrectAnswersOnChange = (ev) => {
    this.change('minCorrectAnswers', ev.target.value);
    this.setState({
      minCorrectAnswers: {
        touched: true,
        errorText: required(ev.target.value, null, this.props),
      },
    });
  }
  amountOnChange = (ev) => {
    this.change('amount', ev.target.value);
  }
  randomOrderOnChange = (ev, active) => {
    this.change('randomOrder', active);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      title, text, buttonText, headerTitle,
      randomOrder, minCorrectAnswers, video, path, amount,
      translate,
    } = this.props;
    const removeTitle = `${translate('remove')}${title ? ` "${title}"` : ''}`;
    return (
      <Card expandable>
        <CardHeader
          title={headerTitle}
          actAsExpander
          showExpandableButton
        />
        <CardText expandable>
          <TextField
            type="text"
            value={title}
            onChange={this.titleOnChange}
            onBlur={this.titleOnChange}
            errorText={this.state.title.touched && this.state.title.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.title`)}
            style={STYLES.block}
          />
          <TextField
            type="text"
            value={text}
            onChange={this.textOnChange}
            onBlur={this.textOnChange}
            errorText={this.state.text.touched && this.state.text.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.text`)}
            style={STYLES.block}
          />
          <TextField
            type="text"
            value={buttonText}
            onChange={this.buttonTextOnChange}
            onBlur={this.buttonTextOnChange}
            errorText={this.state.buttonText.touched && this.state.buttonText.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.buttonText`)}
            style={STYLES.block}
          />
          <TextField
            type="text"
            value={video}
            onChange={this.videoOnChange}
            onBlur={this.videoOnChange}
            errorText={this.state.video.touched && this.state.video.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.video`)}
            style={STYLES.block}
          />
          <TextField
            type="number"
            value={amount}
            onChange={this.amountOnChange}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.amount`)}
            style={STYLES.block}
          />
          <TextField
            type="number"
            value={minCorrectAnswers}
            onChange={this.minCorrectAnswersOnChange}
            onBlur={this.minCorrectAnswersOnChange}
            errorText={this.state.minCorrectAnswers.touched && this.state.minCorrectAnswers.errorText}
            floatingLabelText={translate(`${TRANSLATION_PREFIX}.minCorrectAnswers`)}
            style={STYLES.block}
          />
          <Toggle
            label={translate(`${TRANSLATION_PREFIX}.randomOrder`)}
            toggled={randomOrder}
            onToggle={this.randomOrderOnChange}
            style={STYLES.toggleInput}
            labelStyle={STYLES.basicLabelStyle}
          />
          <QuestionListBuilder path={path} checkpointId={this.props.id} />
        </CardText>
        <CardActions expandable style={STYLES.cardActions}>
          <FlatButtonWithConfirm
            icon={<Trashcan />}
            label={removeTitle}
            confirmationTitle={removeTitle}
            confirmationText={translate(`${TRANSLATION_QUIZ_PREFIX}.removeConfirm`)}
            submitText={translate('remove')}
            onClick={this.onRemove}
            primary
          />
        </CardActions>
      </Card>
    );
  }
}

export default t(CheckpointForm);
